import { render, staticRenderFns } from "./DriverViolation.vue?vue&type=template&id=a08fb1f4&scoped=true&"
import script from "./DriverViolation.vue?vue&type=script&lang=js&"
export * from "./DriverViolation.vue?vue&type=script&lang=js&"
import style0 from "./DriverViolation.vue?vue&type=style&index=0&id=a08fb1f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08fb1f4",
  null
  
)

export default component.exports